/**
 * Created by khanhduong on 11/9/17.
 */
import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';

export default function subscribeReducer(state = initialState.subscribe, { type, name, msg }) {
  switch (type) {
    case types.CHAT_ADD_SUBSCRIBE_SUCCESS: {
      return state.merge(
        {
          byFrom: Immutable(state.byFrom).set(msg.from, msg),
        },
        { deep: true }
      );
    }
    case types.CHAT_REMOVE_SUBSCRIBE_SUCCESS: {
      const subs = state.byFrom.asMutable();
      delete subs[name];
      return state.merge({
        byFrom: Immutable(subs),
      });
    }
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.subscribe;
      return state;
    }
    default:
      return state;
  }
}
